/*
 * Copyright (c) 2019. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
import FeesService from "../FeesService";
import _isNumber from "lodash/isNumber";

class CostCalculator {
  static calculateValueInDispute(divorce) {
    return (
      CostCalculator.calculateValueInDisputeDivorce(divorce) + CostCalculator.calculateValueInDisputePensions(divorce)
    );
  }

  static calculateValueInDisputePensions(divorce) {
    const netIncomePetitioner = parseInt(divorce.netIncomePetitioner, 10);
    const netIncomePartner = parseInt(divorce.netIncomePartner, 10);
    const pensionsExcluded = !!divorce.pensionsExcluded;
    const numberPensions = _isNumber(divorce.numberPensions) ? parseInt(divorce.numberPensions, 10) : 0;
    const numberPensionsPartner = _isNumber(divorce.numberPensionsPartner)
      ? parseInt(divorce.numberPensionsPartner, 10)
      : 0;
    const totalIncome = netIncomePetitioner + netIncomePartner;

    // Wert für die Folgesache VA für jedes zu übertragende Anrecht 10 Prozent des in drei Monaten erzielten
    // Nettoeinkommens der Ehegatten betragen, mindestens jedoch EUR 1.000
    // Source: https://www.iww.de/rvgprof/archiv/famgkg-die-neuen-kosten-nach-dem-famgkg-scheidung-und-versorgungsausgleich-f22163
    let valuePensions = 1000;
    if (!pensionsExcluded) {
      valuePensions = Math.max(1000, totalIncome * 3 * 0.1 * (numberPensions + numberPensionsPartner));
    }
    return valuePensions;
  }

  static calculateValueInDisputeDivorce(divorce) {
    const netIncomePetitioner = parseInt(divorce.netIncomePetitioner, 10);
    const netIncomePartner = parseInt(divorce.netIncomePartner, 10);
    const totalIncome = netIncomePetitioner + netIncomePartner;
    // Minimum value according to § 43 Abs. 1 Satz 2 FamGKG is EUR 3.000
    return Math.max(3000, totalIncome * 3);
  }

  static getProcessCost(valueInDispute, addVat = true) {
    return FeesService.getFeeByValue(valueInDispute, 1.3, addVat);
  }

  static getHearingCost(valueInDispute, addVat = true) {
    return FeesService.getFeeByValue(valueInDispute, 1.2, addVat);
  }

  static getCourtCosts(valueInDispute) {
    return FeesService.getCourtCosts(valueInDispute, 2.0);
  }

  static getFullCosts(valueInDispute, addVat = true) {
    return (
      this.getProcessCost(valueInDispute, addVat) +
      this.getHearingCost(valueInDispute, addVat) +
      FeesService.getExpenses(addVat)
    );
  }
  s;
}

export default CostCalculator;
